import axios from "axios";
import { HEADERS } from "../../UrlAndPaths";

// employee apply Loan

export const applyLeaveStaffAPICall=async(
    body,
    updateListener,
    setSucces,
    setError,
    setMsg
    )=>{
    try{
        const isForm = (typeof FormData !== 'undefined') && (body instanceof FormData)
        const config = isForm ? { headers: { ...(HEADERS?.headers||{}), 'Content-Type': 'multipart/form-data' } } : HEADERS
        console.log('📤 Submitting leave application:', isForm ? 'FormData' : body);
        const res = await axios.post('employee/staffLeave', body, config)
        console.log('📥 Backend response:', res.data);
        if(res.data?._id) {
            console.log('✅ Record created with ID:', res.data._id);
        } else {
            console.warn('⚠️ Backend response missing _id - record may not be saved!');
        }
        if(res.status === 200){
            if(typeof updateListener === 'function') updateListener()
            if(typeof setSucces === 'function') setSucces(true)
            if(typeof setMsg === 'function') setMsg('Applied For Leave Successfully')
        }
    }catch(err){
        if(typeof setError === 'function') setError(true)
        console.error('❌ Leave application failed:', err?.response?.data || err?.response || err)
        if(typeof setMsg === 'function') {
            const errMsg = err?.response?.data?.message || err?.response?.data?.msg || 'Failed to apply leave'
            setMsg(errMsg)
        }
    }
}